import { Component, h, Prop, Host } from '@stencil/core';
import { arrow_right } from 'pn-design-assets/pn-assets/icons.js';

@Component({
  tag: 'pn-product-tile-price',
  styleUrl: 'pn-product-tile-price.scss',
})
export class PnProductTilePrice {
  @Prop() label: string;
  @Prop() amount: string;
  @Prop() currency: string;
  @Prop() url: string;
  render() {
    if (!this.amount) {
      return;
    }
    return this.url ? (
      <Host>
        <h3>
          {this.amount ? <span>{this.amount}</span> : null}
          {this.currency ? <span>{this.currency}</span> : null}
        </h3>
        {this.label ? (
          <a href={this.url}>
            <pn-button small="true" icon={arrow_right}>
              {this.label}
              {/* <pn-icon icon="open-in-new" small="true" color="blue700" /> */}
            </pn-button>
          </a>
        ) : null}
      </Host>
    ) : (
      <Host>
        <h3>
          {this.amount ? <span>{this.amount}</span> : null}
          {this.currency ? <span>{this.currency}</span> : null}
        </h3>
      </Host>
    );
  }
}
